export const LOAD_USER = 'zen/UserForm/LOAD_USER';
export const LOAD_USER_SUCCEEDED = 'zen/UserForm/LOAD_USER_SUCCEEDED';
export const LOAD_USER_FAILED = 'zen/UserForm/LOAD_USER_FAILED';
export const SET_USER = 'zen/UserForm/SET_USER';
export const LOAD_TIMEZONES = 'zen/UserForm/LOAD_TIMEZONES';
export const LOAD_TIMEZONES_SUCCEEDED = 'zen/UserForm/LOAD_TIMEZONES_SUCCEEDED';
export const SAVE_USER = 'zen/UserForm/SAVE_USER';
export const SAVE_USER_SUCCEEDED = 'zen/UserForm/SAVE_USER_SUCCEEDED';
export const SAVE_USER_FAILED = 'zen/UserForm/SAVE_USER_FAILED';
export const VERIFY_PHONE = 'zen/UserForm/VERIFY_PHONE';
export const VERIFY_PHONE_SUCCEEDED = 'zen/UserForm/VERIFY_PHONE_SUCCEEDED';
export const VERIFY_PHONE_FAILED = 'zen/UserForm/VERIFY_PHONE_FAILED';
export const CHECK_PHONE = 'zen/UserForm/CHECK_PHONE';
export const CHECK_PHONE_SUCCEEDED = 'zen/UserForm/CHECK_PHONE_SUCCEEDED';
export const CHECK_PHONE_FAILED = 'zen/UserForm/CHECK_PHONE_FAILED';
export const OPEN_VERIFY_MODAL = 'zen/UserForm/OPEN_VERIFY_MODAL';
export const CLOSE_VERIFY_MODAL = 'zen/UserForm/CLOSE_VERIFY_MODAL';
export const CLEAR_BANNER = 'zen/UserForm/CLEAR_BANNER';
export const CLEAR_STATE = 'zen/UserForm/CLEAR_STATE';

const initialVerify = { isSending: false, isChecking: false, isModalOpen: false, error: null, phone: null, verified: false };

const initialState = {
  user: null,
  isLoading: false,
  loadError: null,
  timezones: [],
  isSaving: false,
  saveError: null,
  banner: null,
  verify: initialVerify,
};

const prettyName = (user = {}) => `${user.first_name || ''} ${user.last_name || ''}`.trim();
const verifiedFlag = (user) => !!user && user.phone_number_verified === true;

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOAD_USER:
      return { ...state, isLoading: true, loadError: null };
    case LOAD_USER_SUCCEEDED:
    case SET_USER:
      return { ...state, isLoading: false, user: payload, verify: { ...state.verify, verified: verifiedFlag(payload) } };
    case LOAD_USER_FAILED:
      return { ...state, isLoading: false, loadError: payload };
    case LOAD_TIMEZONES_SUCCEEDED:
      return { ...state, timezones: payload };
    case SAVE_USER:
      return { ...state, isSaving: true, saveError: null, banner: null };
    case SAVE_USER_SUCCEEDED: {
      const { user, isNew, createAnother } = payload;
      const message = `${prettyName(user)} has been ${isNew ? 'created' : 'updated'}.`;
      return { ...state, isSaving: false, user: createAnother ? null : user, verify: { ...state.verify, verified: verifiedFlag(user) }, banner: { type: 'success', message } };
    }
    case SAVE_USER_FAILED:
      return { ...state, isSaving: false, saveError: payload, banner: { type: 'error', message: payload } };
    case VERIFY_PHONE:
      return { ...state, verify: { ...state.verify, isSending: true, error: null, phone: payload, verified: false } };
    case VERIFY_PHONE_SUCCEEDED:
      return { ...state, verify: { ...state.verify, isSending: false, isModalOpen: true } };
    case VERIFY_PHONE_FAILED:
      return { ...state, verify: { ...state.verify, isSending: false, error: payload } };
    case CHECK_PHONE:
      return { ...state, verify: { ...state.verify, isChecking: true, error: null } };
    case CHECK_PHONE_SUCCEEDED:
      return { ...state, verify: { ...state.verify, isChecking: false, isModalOpen: false, error: null, verified: true } };
    case CHECK_PHONE_FAILED:
      return { ...state, verify: { ...state.verify, isChecking: false, error: payload } };
    case OPEN_VERIFY_MODAL:
      return { ...state, verify: { ...state.verify, isModalOpen: true, error: null } };
    case CLOSE_VERIFY_MODAL:
      return { ...state, verify: { ...state.verify, isModalOpen: false, error: null } };
    case CLEAR_BANNER:
      return { ...state, banner: null };
    case CLEAR_STATE:
      return initialState;
    default:
      return state;
  }
}

export const loadUser = (userId) => ({ type: LOAD_USER, payload: userId });
export const loadUserSucceeded = (user) => ({ type: LOAD_USER_SUCCEEDED, payload: user });
export const loadUserFailed = (message) => ({ type: LOAD_USER_FAILED, payload: message });
export const setUser = (user) => ({ type: SET_USER, payload: user });
export const loadTimezones = () => ({ type: LOAD_TIMEZONES });
export const loadTimezonesSucceeded = (list) => ({ type: LOAD_TIMEZONES_SUCCEEDED, payload: list });
export const saveUser = (options) => ({ type: SAVE_USER, payload: options });
export const saveUserSucceeded = (result) => ({ type: SAVE_USER_SUCCEEDED, payload: result });
export const saveUserFailed = (message) => ({ type: SAVE_USER_FAILED, payload: message });
export const verifyPhone = (phone) => ({ type: VERIFY_PHONE, payload: phone });
export const verifyPhoneSucceeded = () => ({ type: VERIFY_PHONE_SUCCEEDED });
export const verifyPhoneFailed = (message) => ({ type: VERIFY_PHONE_FAILED, payload: message });
export const checkPhone = ({ phone, code }) => ({ type: CHECK_PHONE, payload: { phone, code } });
export const checkPhoneSucceeded = () => ({ type: CHECK_PHONE_SUCCEEDED });
export const checkPhoneFailed = (message) => ({ type: CHECK_PHONE_FAILED, payload: message });
export const openVerifyModal = () => ({ type: OPEN_VERIFY_MODAL });
export const closeVerifyModal = () => ({ type: CLOSE_VERIFY_MODAL });
export const clearBanner = () => ({ type: CLEAR_BANNER });
export const clearState = () => ({ type: CLEAR_STATE });
